import { render, staticRenderFns } from "./PaypalButton.vue?vue&type=template&id=7ca71bfb"
import script from "./PaypalButton.vue?vue&type=script&lang=js"
export * from "./PaypalButton.vue?vue&type=script&lang=js"
import style0 from "./PaypalButton.vue?vue&type=style&index=0&id=7ca71bfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports